import {
  green,
  red,
  blue,
  orange,
  purple,
  teal
} from '@material-ui/core/colors';
import { PaymentSummaries } from '../types';

export const paymentSummary: PaymentSummaries[] = [
  {
    key: 'total_payments',
    col_name: 'Total Payments',
    has_computation: true,
    color: green[600]
  },
  {
    key: 'total_retail_price',
    col_name: 'Total Retails Sales',
    color: blue[600]
  },
  {
    key: 'total_sales',
    col_name: 'Total Sales',
    has_computation: true,
    color: blue[700]
  },
  {
    key: 'number_of_transactions',
    col_name: 'No. of Transactions',
    color: teal[600]
  },
  {
    key: 'total_paid_amount',
    col_name: 'Total Paid Amount',
    color: green[700]
  },
  {
    key: 'total_balance',
    col_name: 'Total Balance Amount',
    color: orange[600]
  },
  {
    key: 'total_kachi_points',
    col_name: 'Redeemed Kachi Points',
    color: purple[500]
  },
  {
    key: 'total_voucher_amount',
    col_name: 'Total Voucher Amount',
    color: red[400]
  }
];

export const excludedPaymentMode = ['VOUCHER', 'KACHI POINTS', 'REFUND'];
